<div class="payforms-filter-chips" fxFlex="" fxLayout="row">
  <div class="payforms-filter-chips__chip-container" fxFlex="" fxLayout="row">
    <mat-chip-listbox selectable="false" #chipList>

      <mat-chip id="sic-chip" removable="true" class="payforms-filter-chips__chip" *ngIf="currentFilter?.sicCd" (removed)="remove('sicCd')">
        <span class="payforms-filter-chips__chip__value">{{currentFilter?.sicCd}}</span>
        <!-- <mat-icon matChipRemove>cancel</mat-icon> -->
      </mat-chip>

      <mat-chip id="employee-chip" removable="true" class="payforms-filter-chips__chip" *ngIf="currentFilter?.employeeName" (removed)="remove('employeeName')">
        <span class="payforms-filter-chips__chip__value">{{currentFilter?.employeeName}}</span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <mat-chip *ngFor="let status of currentFilter?.status" id="status-chip" removable="true" class="payforms-filter-chips__chip" (removed)="removeStatus(status)">
        <span class="payforms-filter-chips__chip__value">{{status === 'New' ? 'Not Submitted' : status}}</span>
        <mat-icon *ngIf="currentFilter?.status?.length > 1" matChipRemove>cancel</mat-icon>
      </mat-chip>

      <mat-chip id="from-chip" removable="true" class="payforms-filter-chips__chip" *ngIf="currentFilter?.fromDate" (removed)="remove('fromDate')">
        <span class="payforms-filter-chips__chip__name">From:</span>
        <span class="payforms-filter-chips__chip__value">{{currentFilter?.fromDate | date: 'MM/dd/yyyy'}}</span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <mat-chip id="to-chip" removable="true" class="payforms-filter-chips__chip" *ngIf="currentFilter?.toDate" (removed)="remove('toDate')">
        <span class="payforms-filter-chips__chip__name">To:</span>
        <span class="payforms-filter-chips__chip__value">{{currentFilter?.toDate | date: 'MM/dd/yyyy'}}</span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

    </mat-chip-listbox>
    <!-- <div class="payforms-filter-chips__actions">
      <div class="payforms-filter-chips__actions__clear" *ngIf="hasAnyFilter()">
        <button id="clear-filter-button" mat-button="" color="primary" (click)="payformsFiltersActions.clear()">Clear Filter</button>
      </div>
    </div> -->

  </div>
</div>
